import ActionTypes from './actionType';

export function ResultDispatch(payload) {
    return {
        type: ActionTypes.ResultForDownload,
        payload
    }
}

export function noResultDispatch(payload) {
    return {
        type: ActionTypes.NoResultForDownload,
        payload
    }
}

export function loadingDispatch() {
    return {
        type: ActionTypes.resultLoading,
    }
}


// WEBPACK FOOTER //
// ./src/reducers/container/resultDispatch.jsx